import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export const useRegulatorLabel = () => {
  const { t } = useTranslation(['common'], { keyPrefix: 'obligations' });

  return useCallback(
    (regulatorName: string): string => {
      const result = t(`regulators.${regulatorName}`, {
        defaultValue: regulatorName,
      });

      return typeof result === 'string' ? result : regulatorName;
    },
    [t]
  );
};
